import { Box } from '@chakra-ui/react'
import { VERSION, FOOTER_BACKGROUND_IMAGE } from '../../config';

const Footer = () => {
  return (
		<Box
			backgroundImage={`url(${FOOTER_BACKGROUND_IMAGE})`}
			minH={'100px'}
		>
			<Box textAlign="center" bg={"rgba(10, 31, 58, 0.5)"} p={5} mt={8} w={"full"} minH={'100px'}>
				<Box color={"gray.400"} fontSize={[13,15]}>
					<Box >Version: {VERSION}</Box>
					<Box>Copyright &copy; Nusic 2022-2023</Box>
				</Box>
			</Box>
		</Box>
  )
}

export default Footer